<ng-container>
  <div class="post post-modern post-height">
    <div class="blog-boxes" [ngClass]="{ 'landscape-layout': contentlet()?.position.length > 0 }">
      <!-- Image Section -->
      <div class="post-img-wrap">
        @if (buildImageSrc() | async | dotCmsCodecEncode; as imageSrc) {
        <div class="blog-layout-image-container">
          <a [routerLink]="'/page' + contentlet()?.urlMap">
            @if (imageSrc !== 'null') {
            <img [src]="imageSrc" alt="Image not found" />
            } @else {
            <img [src]="'/assets/img/image-not-found.jpg'" alt="Image not found" />
            }
          </a>
        </div>
        }
      </div>

      <!-- Content Section -->
      <div class="position-relative blog-container">
        <div class="font-weigth-bold d-flex justify-content-center tag-container position-absolute">
          @for (tag of getTags(contentlet()?.tags); track tag) {
          <div class="tag-title">{{ tag }}</div>
          }
        </div>

        <div class="post-heading">
          <h3 class="font-bold text-xl mb-4 line-clamp">
            <a [routerLink]="'/page/blog/post/' + contentlet()?.urlTitle">{{ contentlet()?.title }}</a>
          </h3>

          @if (isInSideEditor) {
          <p class="mb-2 text-6xl font-bold text-shadow">
            @if (!isInCarousel && !isSSR) {
            <dotcms-editable-text fieldName="teaser" [mode]="'minimal'" [format]="'html'" [contentlet]="contentlet()" />
            } @else {
            {{ contentlet().teaser }}
            }
          </p>
          } @else {
          <div class="content-container">
            <div class="content" [ngClass]="{ expanded: isExpanded }">
              <p class="mb-2 text-6xl font-bold text-shadow" [ishServerHtml]="contentlet()?.teaser"></p>
              @if (shouldShowReadMore && !isExpanded) {
              <span class="three-dot-line">...</span>
              } @if (shouldShowReadMore && !isExpanded) {
              <a href="#" (click)="toggleContent($event)" class="read-more">Read More</a>
              } @if (shouldShowReadMore && isExpanded) {
              <a href="#" (click)="toggleContent($event)" class="show-less">Show Less</a>
              }
            </div>
          </div>
          }
        </div>

        <div class="d-flex author-details">
          <div class="post-author">
            @for (blogAuthor of contentlet()?.author; track blogAuthor) {
            <custom-dot-cms-blog-author [author]="blogAuthor" isBlog="blogAuthor" />
            }
          </div>
          <div class="text-gray-600">
            <span class="post-date md-start">
              <i class="icon-clock"></i>
              {{ contentlet()?.postingDate | date : 'medium' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
